import React from "react";
import { TableBody } from "@material-ui/core";
import _ from "lodash";
import numeral from "numeral";
import moment from "moment";

import EmptyCashflows from "./EmptyCashflows";
import CashflowHeaderRow from "./CashflowHeaderRow";
import { StyledCashFlowTableRow, StyledTableCell, StyledTableHeaderCell, StyledTable } from "./CashFlowsTable";

const CashflowRow = ({ cashflow }) => {
  const isCurrentPeriod = moment.utc().isBetween(moment.utc(cashflow.startDate), moment.utc(cashflow.endDate));

  return (
    <StyledCashFlowTableRow isCurrent={isCurrentPeriod}>
      <StyledTableCell>{moment(cashflow.startDate).utc().format("MM/DD/YYYY")}</StyledTableCell>
      <StyledTableCell>{moment(cashflow.endDate).utc().format("MM/DD/YYYY")}</StyledTableCell>
      <StyledTableCell>{numeral(cashflow.floatingIndexRate).format("0.00%")}</StyledTableCell>
      <StyledTableCell>{numeral(cashflow.collarFloor).format("0.00%")}</StyledTableCell>
      <StyledTableCell>{numeral(cashflow.collarCap).format("0.00%")}</StyledTableCell>
      <StyledTableCell>{numeral(cashflow.notional).format("$0,0.00")}</StyledTableCell>
      <StyledTableCell>{numeral(cashflow.economicBenefit).format("0.00%")}</StyledTableCell>
      <StyledTableCell>{numeral(cashflow.netCashflow).format("$0,0.00")}</StyledTableCell>
    </StyledCashFlowTableRow>
  );
};
const CollarCashflows = ({ cashflows, onExport }) => {
  if (_.isEmpty(cashflows)) {
    return <EmptyCashflows />;
  }

  return (
    <StyledTable className="hide-scrollbar">
      <CashflowHeaderRow>
        <StyledTableHeaderCell>Start Date</StyledTableHeaderCell>
        <StyledTableHeaderCell>End Date</StyledTableHeaderCell>
        <StyledTableHeaderCell>Floating Rate</StyledTableHeaderCell>
        <StyledTableHeaderCell>Floor</StyledTableHeaderCell>
        <StyledTableHeaderCell>Cap</StyledTableHeaderCell>
        <StyledTableHeaderCell>Notional</StyledTableHeaderCell>
        <StyledTableHeaderCell>Economic Benefit</StyledTableHeaderCell>
        <StyledTableHeaderCell>Net Cashflow</StyledTableHeaderCell>
      </CashflowHeaderRow>
      <TableBody>
        {cashflows.map(x => <CashflowRow key={x.id} cashflow={x} />)}
      </TableBody>
    </StyledTable>
  );
};
export default CollarCashflows;
